import React from 'react';

// Banksy is the Stash asset CDN. It is environment-aware so that non-production
// builds resolve against the matching asset bucket.
export const BANKSY_BASE_URLS = {
	edge: 'https://assets-edge.stash.com',
	staging: 'https://assets-staging.stash.com',
	production: 'https://assets.stash.com',
} as const;

type BanksyEnvironment = keyof typeof BANKSY_BASE_URLS;

export const BANKSY_BASE_URL =
	BANKSY_BASE_URLS[window.Stash.env as BanksyEnvironment] ||
	BANKSY_BASE_URLS.edge;

/**
 * Resolves a Banksy asset path to a fully-qualified URL. Relative paths
 * (e.g. `/images/...`) are prefixed with the environment's Banksy base URL;
 * absolute URLs are returned untouched.
 */
export const resolveBanksySrc = (src: string): string =>
	src.startsWith('/') && !src.startsWith('//') ? `${BANKSY_BASE_URL}${src}` : src;

export type BanksyImageProps = Omit<
	React.ImgHTMLAttributes<HTMLImageElement>,
	'src'
> & {
	src: string;
	alt?: string;
};

/**
 * Renders an `<img>` sourced from the Banksy asset CDN. Replaces RISE's
 * `BanksyImage` — pass a relative asset path and it resolves against the
 * environment-aware base URL.
 */
export function BanksyImage({ src, alt = '', ...rest }: BanksyImageProps) {
	return <img src={resolveBanksySrc(src)} alt={alt} {...rest} />;
}

export default BanksyImage;
